module.exports = __webpack_public_path__ + "img/75.4.NH3-N.87f18493.png";